<template>
  <div class="col-span-2 relative">
    <GoogleSignInButton
      class="w-full cursor-pointer text-[10px] sm:text-base flex items-center justify-center gap-4 py-4 border-2 border-gray-300 bg-white rounded-2xl"
      @success="onGoogleSuccess"
      @error="onGoogleError"
      :buttonConfig="{
        theme: 'outline',
        size: 'large',
        text: 'signin_with',
        shape: 'pill',
        logo_alignment: 'left',
      }"
    />

    <!-- Overlay loader mientras espera backend -->
    <div
      v-if="loading"
      class="absolute inset-0 rounded-2xl bg-white/70 flex items-center justify-center z-10"
    >
      <div class="flex items-center gap-3">
        <span class="h-5 w-5 rounded-full border-2 border-gray-300 border-t-mainBlue animate-spin"></span>
        <span class="text-sm text-gray-600 font-semibold">Conectando con Google...</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { GoogleSignInButton } from "vue3-google-signin";
import { server } from "../../../../config/global";
const BASE_URL = server.API_URL;

export default {
  name: "GmailComponent",
  components: { GoogleSignInButton },

  emits: ["loading", "ui-message"],

  data() {
    return {
      loading: false,
      codeInfluencer: this.$route.query.invitation,
    };
  },

  methods: {
    setLoading(val) {
      this.loading = val;
      this.$emit("loading", val);
    },
    sendMessage(text, type = "error") {
      this.$emit("ui-message", { text, type });
    },

    parseJwt(token) {
      const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
      return JSON.parse(decodeURIComponent(escape(atob(base64))));
    },

    async onGoogleSuccess(resp) {
      this.setLoading(true);

      try {
        const idToken = resp?.credential;
        if (!idToken) {
          this.sendMessage("No se recibió el token de Google. Intenta nuevamente.", "error");
          return;
        }

        const claims = this.parseJwt(idToken);

        // Si falta email (a veces pasa según configuración)
        if (!claims?.email) {
          this.sendMessage("Google no devolvió el correo. Revisa permisos e inténtalo otra vez.", "warning");
          return;
        }

        const response = await axios.post(`${BASE_URL}client/login-gmail`, {
          email: claims.email,
          gmail_id: claims.sub,
          name: claims.name,
          profile_image_url: claims.picture,
          store_id: 1,
          influencer_code: this.codeInfluencer,
          id_token: idToken,
        });

        if (response.status === 200) {
          const b = response.data.body;
          const prof = b.attributes.profile.attributes;
          const userable = prof.userable.attributes;

          if (b.attributes.addresses.length) {
            const a = b.attributes.addresses[0].attributes;
            const direction = {
              nombre: a.address,
              lat: a.lat,
              lng: a.lng,
              departamento: a.department,
              provincia: a.city,
              distrito: a.district,
              location: a.free,
            };
            localStorage.setItem("direction", JSON.stringify(direction));
          }

          const dataUser = {
            globalID: b.id,
            globalName: prof.name,
            globalLastName: prof.surnames,
            globalImage: userable.profile_image_url,
            globalValidate: b.attributes.validation.verified,
            glovalEmail: userable.email,
            identificador: b.client_code,
            type: 2,
          };
          localStorage.setItem("auth", JSON.stringify(dataUser));

          if (!prof.cellphone) localStorage.setItem("completecellphone", "true");

          // opcional: mensaje de éxito visible
          this.sendMessage("Inicio de sesión con Google exitoso.", "success");

          if (this.$route.query.redirect) {
            this.$router.push(String(this.$route.query.redirect));
            localStorage.removeItem("open");
          } else {
            location.reload();
            localStorage.removeItem("open");
          }
        } else {
          this.sendMessage("No se pudo iniciar sesión con Google. Inténtalo más tarde.", "error");
        }
      } catch (error) {
        const status = error?.response?.status;
        const backendMsg = error?.response?.data?.message;

        let msg = backendMsg || "Error al iniciar sesión con Google.";
        if (!error?.response) msg = "Problema de conexión. Revisa tu internet e inténtalo otra vez.";

        // si quieres mensajes más específicos:
        if (status === 422) msg = backendMsg || "Datos inválidos para iniciar sesión con Google.";
        if (status === 409) msg = backendMsg || "Conflicto de cuenta. Revisa tu registro.";
        if (status === 500) msg = "Error interno del servidor. Inténtalo más tarde.";

        this.sendMessage(msg, "error");
      } finally {
        this.setLoading(false);
      }
    },

    onGoogleError() {
      this.sendMessage("No se pudo completar el inicio de sesión con Google.", "error");
    },
  },
};
</script>
